import { PropsWithChildren } from 'react';

export const PlanIcon = (props: PropsWithChildren) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M10.001 4.00024V6.00024M14.8581 11.0002H18.001"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M4.00098 11.0002H10.001M10.001 9.00024V13.0002"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M15.3087 18.0002H17.5426C17.7958 18.0002 18.001 17.795 18.001 17.5419V4.45858C18.001 4.20545 17.7958 4.00024 17.5426 4.00024H4.45931C4.20618 4.00024 4.00098 4.20545 4.00098 4.45858V17.5419C4.00098 17.795 4.20618 18.0002 4.45931 18.0002H10.2946C10.403 18.0002 10.5079 17.9618 10.5907 17.8918L13.9625 15.0387"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
};
